import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"

export function list(params) {
    // { page, per_page, symbol, start, end, source }  ?page=1&per_page=10&sortby=id&order=0&type=-1&symbol=USDT&start=2019-06-07&end=2020-08-07&source=BUY
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/amount/history?page=${params.page}&per_page=${params.per_page}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// export function createApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/create`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

// export function destroyApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/destroy`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

